import { container } from '../container';
import type { ICancelSubscriptionRequest, ICreatePaymentSessionRequest, ICreatePaymentSessionResponse, IGetInvoicesRequest, IResumeSubscriptionRequest, ISubscriptionListDTO } from './stripe.api.types';

export class StripeApi {
    static createPaymentSession(params: ICreatePaymentSessionRequest): Promise<ICreatePaymentSessionResponse> {
        return container.AccountHttp.post({
            url: `${process.env.VUE_APP_ACCOUNT_SERVICE_URI}/user-service/payment/stripe/checkout-session`,
            data: params,
        }).then(res => {
            return res
        })
    }

    static cancelSubscription(params: ICancelSubscriptionRequest): Promise<void> {
        return container.AccountHttp.post({
            url: `${process.env.VUE_APP_ACCOUNT_SERVICE_URI}/user-service/payment/stripe/cancel-subscription`,
            data: params,
        }).then(res => {
            return res
        })
    }

    static resumeSubscription(params: IResumeSubscriptionRequest): Promise<void> {
        return container.AccountHttp.post({
            url: `${process.env.VUE_APP_ACCOUNT_SERVICE_URI}/user-service/payment/stripe/resume-subscription/${params.subscription_id}`,
            data: params,
        }).then(res => {
            return res
        })
    }

    static getInvoices(params: IGetInvoicesRequest): Promise<string> {
        return container.AccountHttp.post({
            url: `${process.env.VUE_APP_ACCOUNT_SERVICE_URI}/user-service/payment/stripe/create-portal-session`,
            data: params,
        }).then(res => {
            return res
        })
    }

    static getSubscriptionList(): Promise<ISubscriptionListDTO[]> {
        return container.AccountHttp.get({
            url: `${process.env.VUE_APP_ACCOUNT_SERVICE_URI}/user-service/payment/tenant-user/subscriptions`,
        }).then(res => {
            return res
        })
    }
}
